import React from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import BaseSearchSelect from 'components/atoms/base-search-select';

import s from './styles.module.scss';

import type { BaseSearchSelectProps } from 'components/atoms/base-search-select/types';
import type { IBaseSelectBoxProps } from 'components/atoms/base-select-box/types';

interface IFieldSearchProps {
  fields: IBaseSelectBoxProps;
  search: BaseSearchSelectProps;
}

const FieldSearch: React.FC<IFieldSearchProps> = ({ fields, search }) => {
  return (
    <div className={s.flex}>
      <BaseSelectBox className={s.dropdown} {...fields} />
      <BaseSearchSelect
        className={s.search}
        {...search}
        width="calc(100% - 150px)"
      />
    </div>
  );
};

export default FieldSearch;
